module.exports = __webpack_public_path__ + "img/back-blur.678ae231.png";